(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const syncEngraving = document.currentScript.dataset.syncEngraving === 'true';
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }
    // get product data
    let product = JSON.parse(section.querySelector(".productV3JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productV3VariantJSON").textContent);
    let quantity = 1;

    // gift card properties
    let properties = {};

    // checks if engraving dialog is open
    function engravingIsOpen() {
        return !!section.querySelector(".engrave")?.open;
    }

    // resolve a variant's prices in cents, preferring intelligems so price tests stay in sync
    function variantPrices(variant) {
        return {
            price: parseFloat(window.igData?.price?.getPriceByVariantId(variant.id)) * 100 || variant.price,
            comparePrice: parseFloat(window.igData?.price?.getComparePriceByVariantId(variant.id)) * 100 || variant.compare_at_price
        };
    }

    /************
     Product Swipers
     ************/
    document.querySelectorAll('.productV3VisualSwiper').forEach(swiper => {

        // thumbs
        let target = swiper.dataset.thumbsTarget;
        let thumbsElement = document.querySelector(`[id='${target}']`);

        let thumbsSwiper = new Swiper(document.querySelector(`[id='${target}']`), {
            slidesPerView: 3.5,
            spaceBetween: 15,
            direction: "vertical"
        });

        // swiper
        let productSwiper = new Swiper(document.querySelector(`[id='${swiper.id}']`), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            loop: true,
            thumbs: {
                swiper: thumbsSwiper
            },
            navigation: {
                nextEl: thumbsElement.querySelector(".productV3VisualThumbsNext"),
                prevEl: thumbsElement.querySelector(".productV3VisualThumbsPrev"),
            },
            pagination: {
                el: swiper.querySelector(".productV3VisualSwiperPag"),
                clickable: true
            },
            on: {
                slideChange: function () {
                    // update the thumbnail active class
                    thumbsElement.querySelector(".productV3VisualThumbsSlideImg.active")?.classList.remove("active");
                    thumbsElement.querySelectorAll(".productV3VisualThumbsSlideImg")[this.realIndex]?.classList.add("active");

                    // mobile prev/next buttons
                    if (window.innerWidth < 800) {
                        swiper.querySelector(".productV3VisualSwiperNext").classList.add("active");
                        swiper.querySelector(".productV3VisualSwiperPrev").classList.add("active");

                        // if we're on the first slide, hide the prev button
                        if (this.realIndex === 0) {
                            swiper.querySelector(".productV3VisualSwiperPrev").classList.remove("active");
                        }
                        // if we're on the last slide, hide the next button
                        if (this.realIndex === this.slides.length - 1) {
                            swiper.querySelector(".productV3VisualSwiperNext").classList.remove("active");
                        }
                    }
                }
            }
        });

        // show prev/next on mobile
        if (window.innerWidth < 800) {
            swiper.querySelector(".productV3VisualSwiperNext").classList.add("active");
        }

        // mobile prev/next
        swiper.querySelector(".productV3VisualSwiperNext").addEventListener("click", function () {
            productSwiper.slideNext();
        });
        swiper.querySelector(".productV3VisualSwiperPrev").addEventListener("click", function () {
            productSwiper.slidePrev();
        });

    });

    //

    // disable magic zoom on desktop
    if (window.innerWidth > 800) {
        section.querySelectorAll('.productV3VisualSwiperSlide').forEach(slide => {
            slide.classList.remove('MagicZoom')
            slide.addEventListener('click', function (e) {
                e.preventDefault();
            });
        })
    }

    // play video on slide play click
    section.querySelectorAll(".productV3VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV3VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV3VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll(".productV3 input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // update active variant on select changes
    section.querySelectorAll(".productV3 select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // remove white space lines from upsell descriptions
    section.querySelectorAll('.upsellBodyInfo')?.forEach(element => {
        let text = element.textContent;

        // remove all &nbsp;
        text = text.replace(/\u00A0/g, ' ');
        text = text.replace(/&nbsp;/g, ' ');
        element.textContent = text;
    })

    section.querySelector('.productV3TitleReviews')?.addEventListener('click', function () {
        const reviewsSection = document.querySelector('.reviews');
        if (!reviewsSection) {
            return;
        }

        // let a lazily-loaded reviews widget know it is wanted before we scroll to it
        document.dispatchEvent(new CustomEvent('product:reviews-requested'));

        // offset for the sticky header
        const headerBottom = document.getElementById('headerWrap')?.getBoundingClientRect().bottom || 90;
        const offset = Math.max(105, headerBottom + 16);

        window.scrollTo({
            top: Math.max(0, reviewsSection.getBoundingClientRect().top + window.scrollY - offset),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
    });

    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productV3ATC") || false;
        let priceExists = section.querySelector(".productV3Price") || false;
        let sellingPlanExists = section.querySelector(".productV3Selling") || false;
        let payInstallmentsExits = section.querySelector("shopify-payment-terms") || false;
        let locationsExists = section.querySelector(".productV3Pickup") || false;
        let optionsWrapper = section.querySelector('.productV3Option'); // Wraps the variant options. There can be multiple due to the engraving dialog

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {

            // if engraving dialog is open, use the engraving input as the target element wrapper to find the variant
            if (engravingIsOpen()) {
                optionsWrapper = section.querySelector('.engraveBodyOption');
            }

            // collect all option values by their names, then map to correct order
            let optionsByName = {};

            // collect options from inputs (colors)
            optionsWrapper.querySelectorAll(`.productV3OptionItem.colors`)?.forEach(group => {
                let name = group.dataset.name;
                optionsByName[name] = group.querySelector(`input:checked`)?.value;
            });

            // collect options from radio buttons
            optionsWrapper.querySelectorAll(`.productV3OptionItem.radios`)?.forEach(group => {
                let name = group.dataset.name;
                optionsByName[name] = group.querySelector(`input:checked`)?.value;
            });

            // collect options from selects
            optionsWrapper.querySelectorAll(`.productV3OptionItemSelect`)?.forEach(select => {
                let name = select.dataset.name;
                optionsByName[name] = select?.value;

            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                // normalize option values for comparison
                let variantOptionNames = product.options || [];
                let userOptions = variantOptionNames.map(name => optionsByName[name]?.trim());
                let variantOptions = (variant.options || []).map(opt => opt.trim());

                return JSON.stringify(userOptions) === JSON.stringify(variantOptions);
            });
        }


        // check if variant wasn't found
        if ((activeVariant === null || activeVariant === undefined)) {
            if (productATCExists) {
                // Disable ATC button
                section.querySelectorAll(".productV3ATC").forEach(button => {
                    button.classList.add("oos");
                    button.textContent = "Sold Out — Notify Me When Available";
                });
            }
            return;
        }

        afterpayTrigger()

        // update the selected option text
        optionsWrapper?.querySelectorAll('.productV3OptionItem.colors')?.forEach(function (element) {
            let premiumExists = element.querySelector('.productV3OptionItemLabelChoice.premium') || false;

            // show the selected option in the correct place
            if (optionsWrapper.querySelector('input:checked')?.classList.contains('premium')) {
                if (premiumExists) {
                    optionsWrapper.querySelector('.productV3OptionItemLabelChoice.premium').textContent = ` | ` + element.querySelector('input:checked').value;
                }
                optionsWrapper.querySelector('.productV3OptionItemLabelChoice.regular').textContent = '';
            } else {
                optionsWrapper.querySelector('.productV3OptionItemLabelChoice.regular').textContent = ` | ` + element.querySelector('input:checked').value;
                if (premiumExists) {
                    optionsWrapper.querySelector('.productV3OptionItemLabelChoice.premium').textContent = '';
                }
            }
        });

        /**************
         Variant Image
         ***************/
        // don't update while engraving open
        if (engravingIsOpen()) {
            // get variant image
            let variantImage = variantIDtoEngravingImg[activeVariant.id] || false;

            // update the image in the engraving dialog
            if (variantImage) {
                section.querySelector('.engraveBodyZoomImg').src = variantImage;
            } else {
                section.querySelector('.engraveBodyZoomImg').src = activeVariant.image?.src || '';
            }

        } else {
            section.querySelectorAll('.productV3VisualWrap').forEach(element => {
                // change active swiper
                element.classList.remove("active");
                if (activeVariant.id === parseInt(element.dataset.variantId)) {
                    element.classList.add("active");
                }
            });
        }


        /**************
         Price
         ***************/
        const activePrices = variantPrices(activeVariant);

        if (priceExists) {
            section.querySelector(".productV3PriceReal").textContent = price(activePrices.price * quantity);
            section.querySelector(".productV3PriceReal").setAttribute("data-variant-id", activeVariant.id);
            if (activePrices.comparePrice > activePrices.price) {
                section.querySelector(".productV3PriceReal").classList.add("sale");
                section.querySelector(".productV3PriceCompare").textContent = price(activePrices.comparePrice * quantity);
                section.querySelector(".productV3PriceCompare").setAttribute("data-variant-id", activeVariant.id);
            } else {
                section.querySelector(".productV3PriceReal").classList.remove("sale");
                section.querySelector(".productV3PriceCompare").textContent = "";
                section.querySelector(".productV3PriceCompare").setAttribute("data-variant-id", activeVariant.id);
            }
        }

        // update save price
        section.querySelectorAll('.productV3VisualSave').forEach(element => {
            element.classList.remove('active');
        })

        if (activeVariant.compare_at_price > activeVariant.price) {
            let save = (1 - (activeVariant.price / activeVariant.compare_at_price)) * 100;
            section.querySelectorAll('.productV3VisualSave').forEach(element => {
                element.classList.add('active');
                element.textContent = `${save.toFixed(0)}% OFF`;
            })
        }

        // update the pack size prices and save badges in JS so intelligems price tests stay in sync
        section.querySelectorAll('.productV3OptionItemPacksLabel').forEach(element => {
            const variantID = parseInt(element.dataset.variantId);
            const packVariant = product.variants.find(variant => variant.id === variantID);

            if (!packVariant) {
                return;
            }

            const packPrices = variantPrices(packVariant);

            // save the elements in this pack row
            const saveElement = element.querySelector('.productV3OptionItemPacksLabelBodyLeftSave');
            const compareElement = element.querySelector('.productV3OptionItemPacksLabelBodyPriceCompare');
            const realElement = element.querySelector('.productV3OptionItemPacksLabelBodyPriceReal');

            realElement.textContent = price(packPrices.price, true);

            // hide the compare price and the save badge when the variant isn't discounted
            if (packPrices.comparePrice <= packPrices.price) {
                compareElement.classList.remove('active');
                compareElement.textContent = '';
                saveElement.classList.remove('active');
                saveElement.textContent = '';
                return;
            }

            compareElement.classList.add('active');
            compareElement.textContent = price(packPrices.comparePrice, true);

            const save = (1 - (packPrices.price / packPrices.comparePrice)) * 100;
            saveElement.classList.add('active');
            saveElement.textContent = `${save.toFixed(0)}% off`;
        })

        // update engraving price
        let engravingExists = section.querySelector('.productV3Engrave') || false;
        if (engravingExists) {
            const dialog = section.querySelector('.engrave');
            const rawFee = dialog?.dataset.engravingFee;
            const fee = rawFee === undefined || rawFee === '' ? NaN : Number(rawFee);
            const format = amount => {
                try {
                    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
                        style: 'currency', currency: Shopify.currency.active
                    }).format(amount / 100);
                } catch (_) { return price(amount); }
            };
            section.querySelector(".engraveBodyATCReceiptItemPrice.real").textContent = format(activeVariant.price);
            if (Number.isFinite(fee) && fee >= 0) {
                section.querySelector(".engraveBodyATCReceiptItemPrice.total").textContent = format(activeVariant.price + fee);
                const feeElement = section.querySelector('.engraveBodyATCReceiptItemPrice.fee');
                if (feeElement) feeElement.textContent = format(fee);
            }

        }


        /**************
         Selling Plan
         ***************/
        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (plan.selling_plan_id === parseInt(document.querySelector('.productV3SellingLabelBodyBottomWrapContentLabelInput:checked').value)) {
                    activeVariantPlan = plan;
                }
            }

            // update savings text
            let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;
            section.querySelector('.productV3SellingLabelBodyTopTitle').textContent = `Subscribe & Save ` + save.toFixed(0) + `%`;

            // save parent elements
            const once = section.querySelector(".productV3SellingLabelBody.once");
            const sub = section.querySelector(".productV3SellingLabelBody.sub");

            // update compare at price
            once.querySelector(".productV3SellingLabelBodyPriceCompare").textContent = "";
            sub.querySelector(".productV3SellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
            if (activePrices.comparePrice > activePrices.price) {
                once.querySelector(".productV3SellingLabelBodyPriceCompare").textContent = price(activePrices.comparePrice * quantity, true);
            }

            // update actual price
            once.querySelector(".productV3SellingLabelBodyPriceReal").textContent = price(activePrices.price * quantity, true);
            sub.querySelector(".productV3SellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);


            // update price outside of selling plan module if selling plan is selected
            if (priceExists && section.querySelector(".productV3SellingLabelInput:checked")?.value === "sub") {
                section.querySelector(".productV3PriceReal").textContent = price(activeVariantPlan.price * quantity);
                section.querySelector(".productV3PriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity);
            }
        }

        /**************
         Pay Installments
         ***************/
        if (payInstallmentsExits) {
            // update payments form data
            section.querySelector('.productV3PaymentsInput').value = activeVariant.id;
            section.querySelector('shopify-payment-terms').dataset.variantId = activeVariant.id;
            section.querySelector('shopify-payment-terms').setAttribute('variant-id', activeVariant.id);
        }


        /**************
         ATC Enable/Disable
         ***************/
        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll(".productV3ATC").forEach(button => {
                button.textContent = "Add To Cart";
                button.classList.remove("oos");
                if (button.classList.contains("checkout")) {
                    button.textContent = "Checkout";
                }
            });
        } else {
            section.querySelectorAll(".productV3ATC").forEach(button => {
                button.textContent = "Sold Out — Notify Me When Available";
                button.classList.add("oos");
            });
        }


        /**************
         Pickup Locations
         ***************/
        if (locationsExists) {
            // update pickup location
            await updateLocation(activeVariant.id, '.productV3Pickup');

            // update dialog pickup locations
            await updateLocation(activeVariant.id, '.pickupContentBody');
        }

        // update properties (gift card)
        section.querySelectorAll(".productV3GiftCardInput")?.forEach(function (element) {
            properties[element.name] = element.value;
        });

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV3QuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV3QuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productV3QuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productV3QuantityControlsValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Product ATC
     ***************/
    let purchasePending = false;
    section.querySelectorAll('.productV3ATC, .engraveBodyATC ')?.forEach(button => {
        button.addEventListener("click", async function () {
            if (purchasePending || this.disabled) return;
            const isEngraving = this.classList.contains("engraving");

            // check for out of stock
            if (this.classList.contains("oos")) {
                // check email
                let {value: email} = await Swal.fire({
                    title: product.title,
                    text: "Enter your email to be notified when this product is back in stock.",
                    input: "email",
                    inputPlaceholder: "Email Address",
                    confirmButtonText: "Notify Me When Available",
                });

                // confirm email is returned
                if (!email) {
                    return;
                }

                // add to waitlist
                let formData = new FormData();
                formData.append("a", await klaviyo.account());
                formData.append("email", email);
                formData.append("g", "");
                formData.append("variant", activeVariant.id);
                formData.append("product", product.id);
                formData.append("platform", "shopify");
                formData.append("subscribe_for_newsletter", false);
                fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
                    method: "POST",
                    body: formData
                })

                // show success message
                await Swal.fire({
                    title: "Success!",
                    text: "You will be notified when this product is back in stock.",
                    confirmButtonText: "OK",
                });

                return;
            }

            // check for engraving
            if (isEngraving) {
                let engravingText = section.querySelector(".engraveBodyInput").value.toUpperCase();

                // check if engraving is empty
                if (engravingText.trim().length === 0) {
                    await Swal.fire({
                        target: section.querySelector('.engrave'),
                        title: "Engraving Required",
                        text: "Can't leave text empty",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    this.classList.remove("loading");
                    return;
                }

                // add engraving to properties
                properties['Engraving'] = engravingText;

            } else {
                // remove engraving property if it exists
                delete properties['Engraving'];
            }

            purchasePending = true;
            const buttons = Array.from(section.querySelectorAll('.productV3ATC, .engraveBodyATC '));
            const disabledStates = buttons.map(button => button.disabled);
            buttons.forEach(button => { button.disabled = true; });
            this.classList.add("loading");
            this.setAttribute('aria-busy', 'true');
            try {


            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                    properties: properties || null
                }]
            };


            // check for selling plan
            if (section.querySelector('.productV3SellingLabelInput.sub')?.checked) {
                // find the correct selling_plan_allocation
                let activeVariantPlan = activeVariant.selling_plan_allocations[0];
                // find the correct selling_plan_allocation
                for (let plan of activeVariant.selling_plan_allocations) {
                    if (plan.selling_plan_id === parseInt(section.querySelector('.productV3SellingLabelBodyBottomWrapContentLabelInput:checked').value)) {
                        activeVariantPlan = plan;
                    }
                }
                formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
            }

            // check for upsell
            document.querySelectorAll('.productV3UpsellItemContainerContentLabelInput')?.forEach(element => {
                if (element.checked) {
                    formData.items.push({
                        quantity: 1,
                        id: parseInt(element.value)
                    });

                    // track
                    window.igEvents = window.igEvents || [];
                    window.igEvents.push({
                        "event": "added_to_cart_pdp"
                    })

                }
            })

            // Keep a receipt of this request; later option edits cannot alter it.
            const submittedItems = JSON.parse(JSON.stringify(formData.items));
            const added = await addProduct(formData, {product, section});
            if (!Array.isArray(added?.items) || !added.items.length) {
                const error = new Error(added?.description || 'Please review your selection and try again.');
                error.cartError = true;
                throw error;
            }
            section.dispatchEvent(new CustomEvent('code118:product-added', {
                bubbles: true, detail: {items: submittedItems}
            }));
            } catch (error) {
                await Swal.fire({
                    target: engravingIsOpen() ? section.querySelector('.engrave') : document.body,
                    title: 'Unable to add to cart',
                    text: error.cartError ? error.message : 'Please try again. Your selection has been kept.',
                    icon: 'error', confirmButtonText: 'OK'
                });
                return;
            } finally {
                purchasePending = false;
                this.classList.remove("loading");
                this.removeAttribute('aria-busy');
                buttons.forEach((button, index) => { button.disabled = disabledStates[index]; });
            }

            // checkout
            if (this.classList.contains("checkout")) {
                window.location.href = `${Shopify.routes.root}checkout`;
                return;
            }

            // check for engraving and close popup
            if (isEngraving) {
                closePopup();
            }

            // open cart
            await openCart();
        });
    });

    /**************
     Pickup Locations Rendering
     ***************/

    // inserts pickup location HTML into section
    // Takes variantID and the target class to insert the pickup locations
    async function updateLocation(variantID, targetClass) {
        // section rendering API - fetch pickup locations
        fetch(window.Shopify.routes.root + `variants/${variantID}/?section_id=${section.id}`)
            .then(response => response.text())
            .then(text => {
                // create temp div to parse html
                let html = document.createElement('div');
                html.innerHTML = text;
                let locations = html.querySelector(`${targetClass}`);

                // insert locations
                if (locations && locations.innerHTML.trim().length) {
                    section.querySelector(`${targetClass}`).innerHTML = locations.innerHTML;

                    // attach event listeners
                    // open pickup event listener
                    section.querySelectorAll(".openPickup")?.forEach(function (element) {
                        element.addEventListener("click", openPickup);
                    });
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    /**************
     Dropdowns
     ***************/
    section.querySelectorAll(".productV3DropdownTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Upsell Dropdowns
     ***************/
    section.querySelectorAll(".productV3UpsellOpen")?.forEach(element => {
        element.addEventListener("click", function () {
            // toggle active class
            this.classList.toggle("active");

            section.querySelector('.productV3UpsellOpenTxt').textContent = "Show all add-ons";
            if (this.classList.contains("active")) {
                section.querySelector('.productV3UpsellOpenTxt').textContent = "Hide";
            }

            // toggle the dropdown
            section.querySelector(".productV3Upsell").querySelector(".productV3UpsellDropdown").classList.toggle("active");
        });
    });

    // upsell item dropdown
    section.querySelectorAll('.productV3UpsellItemContainerContentInfo')?.forEach(element => {
        element.addEventListener('click', function () {
            // open info dialog
            element.querySelector('.productV3UpsellItemContainerContentInfoTooltip').click();


        })
    })

    // listen for input switch, if the input is checked make sure the dropdown is open
    section.querySelectorAll('.productV3UpsellItemContainerContentLabelInput')?.forEach(element => {
        element.addEventListener('change', function () {
            // check if dropdown exists
            let dropDownExists = element.closest('.productV3UpsellItem').querySelector('.productV3UpsellItemBodyDrop') || false;

            if (!dropDownExists) {
                return;
            }

            // toggle the dropdown
            element.closest('.productV3UpsellItem').querySelector('.productV3UpsellItemBodyDrop').classList.toggle('active');

        })
    })


    /**************
     Upsell Logic
     ***************/
    section.querySelectorAll('.productV3UpsellItem')?.forEach(upsell => {
        // when an upsell select input is changed
        upsell.querySelector('.productV3UpsellItemBodyDropWrapContentSelect')?.addEventListener('change', function () {

            let selectedOption = this.querySelector('option:checked');
            let variant = JSON.parse(selectedOption.value);

            // update the image
            upsell.querySelector('.productV3UpsellItemBodyDropWrapContentImg').src = selectedOption.dataset.image;
            upsell.querySelector('.productV3UpsellItemContainerContentInfoUpperImg').src = selectedOption.dataset.image;


            // update the value of the main input (we use this for the ATC)
            upsell.querySelector('.productV3UpsellItemContainerContentLabelInput').value = variant.id;

            // update the price
            upsell.querySelector('.productV3UpsellItemContainerPriceReal').textContent = price(variant.price);
            upsell.querySelector('.productV3UpsellItemContainerPriceReal').setAttribute('data-variant-id', variant.id);
            upsell.querySelector('.productV3UpsellItemContainerPriceCompare').textContent = "";
            upsell.querySelector('.productV3UpsellItemContainerPriceCompare').setAttribute('data-variant-id', variant.id);
            if (variant.compare_at_price > variant.price) {
                upsell.querySelector('.productV3UpsellItemContainerPriceCompare').textContent = price(variant.compare_at_price);
            }
        });
    })


    /**************
     Upsell Switch Product
     ***************/
    // Some products have links between them and a similar product
    // ie. The classic wallet and the Magsafe.
    // In the upsells, allow the user to toggle between the two products
    section.querySelectorAll('.productV3UpsellItemBodyDropWrapContentLinkedLabelInput')?.forEach(input => {
        input.addEventListener('change', function () {
            let linkedProduct = JSON.parse(this.value);

            if (!linkedProduct) return;

            // update the upsell info
            let upsellContainer = input.closest('.productV3UpsellItem');

            // update price
            upsellContainer.querySelector('.productV3UpsellItemContainerPriceReal').textContent = price(linkedProduct.price, true);
            upsellContainer.querySelector('.productV3UpsellItemContainerPriceCompare').textContent = '';
            if (linkedProduct.compare_at_price > linkedProduct.price) {
                upsellContainer.querySelector('.productV3UpsellItemContainerPriceCompare').textContent = price(linkedProduct.compare_at_price, true);
            }

            // update image
            upsellContainer.querySelector('.productV3UpsellItemBodyDropWrapContentImg').src = linkedProduct.featured_image + '&width=200';
            upsellContainer.querySelector('.productV3UpsellItemContainerContentInfoUpperImg').src = linkedProduct.featured_image + '&width=200';

            // update options
            let originalSelectedOption = JSON.parse(upsellContainer.querySelector('.productV3UpsellItemBodyDropWrapContentSelect option:checked')?.value);

            upsellContainer.querySelector('.productV3UpsellItemBodyDropWrapContentSelect').innerHTML = '';
            linkedProduct.variants.forEach((variant) => {
                let option = document.createElement('option');
                option.value = JSON.stringify(variant);
                let soldOut = ''
                if (!variant.available) {
                    soldOut = ' (SOLD OUT)';
                    option.disabled = true;
                }
                option.textContent = variant.title + soldOut;
                option.dataset.image = variant.featured_image.src + '&width=200';
                upsellContainer.querySelector('.productV3UpsellItemBodyDropWrapContentSelect').appendChild(option);
            })

            // try to reselect the original option if it exists
            upsellContainer.querySelectorAll('option').forEach(option => {
                let variant = JSON.parse(option.value);
                if (variant.title === originalSelectedOption.title) {
                    option.selected = true;

                    // trigger change event to update the rest of the upsell
                    upsellContainer.querySelector('.productV3UpsellItemBodyDropWrapContentSelect').dispatchEvent(new Event('change'));
                }
            })

            // update info popup
            let infoPopupID = upsellContainer.querySelector('.productV3UpsellItemContainerContentInfoTooltip').dataset.target;
            let infoPopup = document.querySelector(`#${infoPopupID}`);
            infoPopup.querySelector('.upsellBodyTitle').textContent = linkedProduct.title;
            infoPopup.querySelector('.upsellBodyInfo').innerHTML = linkedProduct.description;

            // update the first image
            infoPopup.querySelector('.upsellBodySwiperSlideImg').src = linkedProduct.featured_image + '&width=400';


        })
    })


    /**************
     Pickup Dialog
     ***************/
    // open pickup
    function openPickup() {
        section.querySelector(".pickup")?.showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    // dialog close event
    section.querySelector(".pickup")?.addEventListener("close", async function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // close pickup
    function closePickup() {
        section.querySelector(".pickup")?.close();
    }

    // open pickup event listener
    section.querySelectorAll(".openPickup")?.forEach(function (element) {
        element.addEventListener("click", openPickup);
    });

    // close pickup event listener
    section.querySelectorAll(".closePickup")?.forEach(function (element) {
        element.addEventListener("click", closePickup);
    });

    section.querySelector(".pickup")?.addEventListener("click", function (e) {
        if (e.target === this) {
            closePickup();
        }
    })

    // register dialog
    if (section.querySelector(".pickup")) {
        dialogPolyfill.registerDialog(section.querySelector(".pickup"));
    }

    /**************
     Engraving Dialog
     ***************/

    function syncVariantOptions(wrapper, variant) {
        if (!wrapper || !variant) return false;
        const changes = [];

        for (const [index, name] of product.options.entries()) {
            const value = variant.options[index];
            const group = Array.from(wrapper.querySelectorAll('.productV3OptionItem.colors, .productV3OptionItem.radios'))
                .find(element => element.dataset.name === name);
            const select = Array.from(wrapper.querySelectorAll('.productV3OptionItemSelect'))
                .find(element => element.dataset.name === name);

            if (group) {
                const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
                const match = inputs.find(input => input.value === value && !input.disabled
                    && getComputedStyle(input.closest('label')).display !== 'none');
                if (!match) return false;
                changes.push(() => inputs.forEach(input => { input.checked = input === match; }));
            } else if (select) {
                if (!Array.from(select.options).some(option => option.value === value && !option.disabled)) return false;
                changes.push(() => { select.value = value; });
            } else {
                return false;
            }
        }

        changes.forEach(change => change());
        return true;
    }

    function openEngraving() {
        const dialog = section.querySelector('.engrave');
        if (!dialog || dialog.open) return;
        if (syncEngraving && !syncVariantOptions(section.querySelector('.engraveBodyOption'), activeVariant)) {
            Swal.fire({
                title: 'Engraving unavailable for this color',
                text: 'Choose another wallet color to add engraving.',
                icon: 'info'
            });
            return;
        }
        dialog.showModal();
        document.querySelector('body').classList.add('noScroll');
        updateProduct();
    }

    // open engrave dialog
    section.querySelectorAll('.productV3Engrave')?.forEach(function (element) {
        element.addEventListener('click', openEngraving);
    })

    // close engrave
    function closePopup() {
        section.querySelector(".engrave").close();
        document.querySelector("body").classList.remove("noScroll");
        if (!syncEngraving) updateProduct();
    }

    // close engrave event listener
    section.querySelectorAll(".closeEngraving")?.forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    section.querySelector(".engrave")?.addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    })

    // close event
    section.querySelector(".engrave")?.addEventListener("close", function () {
        if (this.open) return;
        document.querySelector("body").classList.remove("noScroll");
        if (syncEngraving) {
            syncVariantOptions(section.querySelector('.productV3Option'), activeVariant);
            updateProduct();
        }
    });

    // register dialog
    if (section.querySelector(".engrave")) {
        dialogPolyfill.registerDialog(section.querySelector(".engrave"));
    }

    // check query params for engraving=true, if so open engraving
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('engraving') === 'true') {
        if (syncEngraving) {
            openEngraving();
        } else {
            section.querySelector(".engrave").showModal();
            document.querySelector("body").classList.add("noScroll");
        }
    }

    // listen for engraving input change
    section.querySelectorAll(".engraveBodyInput")?.forEach(function (element) {
        element.addEventListener('input', function () {

            // strip any emojis
            let value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');

            // limit to 14 char
            if (value.length > 14) {
                value = value.substring(0, 14);
            }

            element.value = value;
            section.querySelector('.engraveBodyZoomTxt').textContent = value;

        })
    })


    document.addEventListener("DOMContentLoaded", () => {
        afterpayTrigger()
    });


    function afterpayTrigger() {

        // Afterpay overrides - hide popup button
        function overrideAfterpay() {
            const placement = section.querySelector('square-placement');
            if (placement && placement.shadowRoot) {
                const logoLink = placement.shadowRoot.querySelector('#logo-link');
                const logo = placement.shadowRoot.querySelector('.afterpay-logo');
                if (logoLink && logo) {
                    logoLink.style.setProperty('display', 'none', 'important');
                    logo.style.setProperty('pointer-events', 'none', 'important');
                    return true;
                }
            }
            return false;
        }

        // Try to override Afterpay buttons
        let maxAttempts = 30;
        const interval = setInterval(() => {
            if (overrideAfterpay() || maxAttempts <= 0) {
                clearInterval(interval);
            }
            maxAttempts--;
        }, 100);

    }

    /**************
     Product Bottom
     ***************/

    // the Add To Cart bar reveals once the in-form button scrolls out of view
    const bottomBar = section.querySelector("#productV3Bottom");
    const formATC = section.querySelector(".productV3ATC");

    if (bottomBar && formATC) {
        let barVisible = false;

        window.addEventListener("scroll", function () {
            if (window.innerWidth >= 800) {
                return;
            }

            const passed = window.scrollY > formATC.offsetTop;
            if (passed !== barVisible) {
                bottomBar.classList.toggle("active", passed);
                barVisible = passed;
            }
        }, {passive: true});
    }

    /**************
     Summary Sticky
     ***************/

    const sticky = section.querySelector("#productV3Sticky");

    if (sticky) {
        const stickyLink = sticky.querySelector("a");
        const stickyFinish = sticky.querySelector(".productV3StickyFinish");
        const stickyCount = sticky.querySelector(".productV3StickyCount");
        const stickySelection = sticky.querySelector(".productV3StickySelection");
        const stickyCTA = stickyLink.textContent.trim();
        const colorSelector = '.productV3Option input[type="radio"][aria-label^="Color:"]';
        const addOnSelector = "input.productV3UpsellItemContainerContentLabelInput";
        let colorChosen = false;
        let stickyPending = false;

        // the bar lives on the body so it is not clipped by the section's own stacking context
        document.body.append(sticky);

        function setText(element, text) {
            if (element.textContent !== text) {
                element.textContent = text;
            }
        }

        function updateSummary() {
            const color = [...section.querySelectorAll(colorSelector)].find(input => input.checked)?.value || "";
            const addOns = new Set([...section.querySelectorAll(addOnSelector)]
                .filter(input => input.checked && !input.disabled)
                .map(input => input.getAttribute("aria-label") || input.value));

            const reviewing = colorChosen || addOns.size > 0;
            const addOnText = addOns.size ? `${addOns.size} add-on${addOns.size === 1 ? "" : "s"}` : "";
            const divider = color && addOnText ? " · " : "";

            setText(stickyFinish, color);
            setText(stickyCount, divider + addOnText);
            stickyCount.hidden = !addOnText;
            stickySelection.hidden = !reviewing || (!color && !addOnText);
            stickySelection.title = color + divider + addOnText;
            setText(stickyLink, reviewing ? "Review my selection" : stickyCTA);
        }

        function updateSticky() {
            stickyPending = false;
            updateSummary();

            const overlay = document.body.classList.contains("noScroll") || document.querySelector("dialog[open]");
            const belowPurchase = formATC && formATC.getBoundingClientRect().bottom < 90;
            sticky.hidden = !(belowPurchase && !overlay);

            // keep clear of the theme editor preview bar
            const preview = document.querySelector('#preview-bar-iframe, iframe[src*="preview-bar"]');
            sticky.style.setProperty("--preview-offset", preview ? "50px" : "0px");
        }

        function scheduleSticky() {
            if (!stickyPending) {
                stickyPending = true;
                requestAnimationFrame(updateSticky);
            }
        }

        stickyLink.addEventListener("click", function (e) {
            e.preventDefault();

            // on mobile the options matter more than the gallery, so scroll to them directly
            const options = section.querySelector(".productV3Option");
            const target = window.innerWidth < 800 && options ? options : section;

            window.scrollTo({
                top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 105),
                behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
            });

            target.setAttribute("tabindex", "-1");
            target.focus({preventScroll: true});
        });

        section.addEventListener("change", function (e) {
            if (e.target.matches(colorSelector)) {
                colorChosen = true;
            }
            scheduleSticky();
        });

        window.addEventListener("scroll", scheduleSticky, {passive: true});
        window.addEventListener("resize", scheduleSticky);
        new MutationObserver(scheduleSticky).observe(document.body, {attributes: true, attributeFilter: ["class"]});
        updateSticky();
    }
}());

